<div
  class="tile"
  [class.tile--highlighted]="highlighted()"
  role="img"
  [attr.aria-label]="tooltip()"
  [andorTooltip]="tooltip()">
  <svg [attr.viewBox]="viewBox" preserveAspectRatio="xMidYMid meet" aria-hidden="true">
    <g [attr.transform]="tableTransform()">
      <rect
        class="table"
        [attr.x]="table.x"
        [attr.y]="table.y"
        [attr.width]="table.width"
        [attr.height]="table.height"
        [attr.rx]="table.radius" />

      @for (seat of seats(); track $index) {
        <circle class="seat" [attr.cx]="seat.x" [attr.cy]="seat.y" [attr.r]="seatRadius" />
      }
    </g>

    <path class="wall" [attr.d]="doorGeo().wallPath" />

    @if (doorClosed()) {
      <path class="door-leaf door-leaf--closed" [attr.d]="doorGeo().leafClosedPath" />
      <circle
        class="door-handle"
        [attr.cx]="doorGeo().handle.cx"
        [attr.cy]="doorGeo().handle.cy"
        [attr.r]="doorGeo().handle.r" />
    } @else {
      <path class="door-swing" [attr.d]="doorGeo().swingPath" />
      <path class="door-leaf" [attr.d]="doorGeo().leafOpenPath" />
    }
  </svg>

  <div class="overlay">
    <span class="plate">
      <span class="plate__name">{{ room().name }}</span>
    </span>

    <span class="count-badge" [style.top.%]="badgeTop()">
      <fa-icon [icon]="faUser"></fa-icon>
      {{ room().memberCount }}
    </span>

    @if (room().schedule || room().isPrivate || room().hasPassword) {
      <span class="meta meta--bottom">
        @if (room().schedule) {
          <fa-icon [icon]="faClock" [andorTooltip]="'Scheduled' | translate"></fa-icon>
        }
        @if (room().isPrivate) {
          <fa-icon
            class="lock"
            [class.lock--closed]="doorClosed()"
            [icon]="faLock"
            [andorTooltip]="'Private' | translate"></fa-icon>
        }
        @if (room().hasPassword) {
          <fa-icon [icon]="faKey" [andorTooltip]="'Password protected' | translate"></fa-icon>
        }
      </span>
    }
  </div>
</div>
